/** TODO: Determine if this enum is still required with CARE-4902 changes */
var PrimaryContact;
(function (PrimaryContact) {
    PrimaryContact["ME"] = "me";
    PrimaryContact["SOMEBODY_ELSE"] = "somebodyElse";
    PrimaryContact["SCHEDULING_USER"] = "schedulingUser";
})(PrimaryContact || (PrimaryContact = {}));

export { PrimaryContact };
